import { Box, InputAdornment, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography, Button } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ConfirmDialog from '../../../components/ConfirmDialog';
import AddEditUsuario from './AddEditUsuario';
import ReadOnlyRowUsuario from './ReadOnlyRowUsuario';
// import { useUsersMutation } from '../../../hooks/mutations';

const TablaUsuarios = ({ usuarios, titulo, currentUser }) => {
    const [openAddEditUsuario, setOpenAddEditUsuario] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    // const usersMutation = useUsersMutation();

    const [openDialog, setOpenDialog] = useState(false);
    const [deleteRow, setDeleteRow] = useState({ id: 0 });
    const [searchState, setSearchState] = useState('');
    const [shownUsers, setShownUsers] = useState(usuarios);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    useEffect(() => {
        setShownUsers(newUsersSearch(searchState));
    }, [usuarios]);

    // Función para abrir el modal en modo "Crear"
    const handleAddClick = () => {
        setIsUpdate(false);
        setSelectedRow(null);
        setOpenAddEditUsuario(true);
    };

    const handleResponse = async (opcion, rowId) => {
        if(opcion === 'aceptar') {
            // await usersMutation.mutateAsync({comando: "CMD_DELETE_USER", data: {rowId: rowId}});
            //console.log("Borrar usuario:", rowId);
        }
    }

    const handleSearch = (event) => {
        const newValue = event.target.value;
        setSearchState(newValue);
        setShownUsers(newUsersSearch(newValue));
    }

    const newUsersSearch = (searchString) => {
        const newUsers = usuarios?.filter((u) =>
            u.name?.toLowerCase().includes(searchString.toLowerCase()) ||
            u.email?.toLowerCase().includes(searchString.toLowerCase())
        );
        setPage(0);
        return newUsers;
    }

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - shownUsers?.length) : 0;

    return (
        <Fragment>
            {/* CABECERA: Botón Agregar - Título - Buscador */}
            <Stack direction='row' pr={3} pl={2} component={Paper} elevation={5} sx={{ alignItems: 'center', justifyContent: 'space-between', bgcolor: 'white' }}>
                <Box sx={{ width: '30%' }}>
                    {(currentUser?.tipoUsuario === 'superusuario' || currentUser?.tipoUsuario === 'administrador') && (
                        <Button variant="contained" startIcon={<AddIcon />} onClick={handleAddClick}>
                            Agregar Usuario
                        </Button>
                    )}
                </Box>
                
                <Typography variant="h5" component="h5" p={2} align='center' sx={{ width: '40%' }}>
                    {titulo}
                </Typography>

                <TextField
                    size="small" type="text" label='Buscar' value={searchState} variant="outlined"
                    onChange={handleSearch} style={{ width: '30%' }}
                    InputProps={{ endAdornment: (<InputAdornment position="end"><SearchIcon /></InputAdornment>) }}
                />
            </Stack>

            <Box m='auto' mt={6} style={{ maxWidth: '1600px', backgroundColor: 'white' }}>
                <TableContainer pr={3} component={Paper} elevation={5} style={{ maxHeight: 620, maxWidth: 1600 }}>
                    <Table stickyHeader size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell align='left'></TableCell>
                                <TableCell align='left'>ID</TableCell>
                                <TableCell align='left'>Nombre</TableCell>
                                <TableCell align='left'>Email</TableCell>
                                <TableCell align='center'>Rol</TableCell>
                                <TableCell align='left'>Controles</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(rowsPerPage > 0 ? shownUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : shownUsers)
                                ?.map((row, i) => (
                                <ReadOnlyRowUsuario
                                    key={'user_' + i} row={row}
                                    setOpenDialog={setOpenDialog}
                                    setOpenAddEditDialog={setOpenAddEditUsuario}
                                    setIsUpdate={setIsUpdate}
                                    setDeleteRow={setDeleteRow}
                                    selectedRow={selectedRow}
                                    setSelectedRow={setSelectedRow}
                                />
                            ))}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 57 * emptyRows }}><TableCell colSpan={6} /></TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]} component="div" count={usuarios?.length || 0}
                    rowsPerPage={rowsPerPage} page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(e) => { setRowsPerPage(+e.target.value); setPage(0); }}
                />
            </Box>

            <ConfirmDialog
                openDialog={openDialog} setOpenDialog={setOpenDialog}
                texto='Por favor confirme que desea borrar al usuario:'
                identificador={deleteRow?.name + ' (' + deleteRow?.email + ')'}
                rowId={deleteRow.id} handleResponse={handleResponse}
            />

            {/* MODAL DE CREACIÓN Y EDICIÓN */}
            {openAddEditUsuario && (
                <AddEditUsuario
                    openDialog={openAddEditUsuario}
                    setOpenDialog={setOpenAddEditUsuario}
                    isUpdate={isUpdate}
                    selectedRow={selectedRow}
                />
            )}
        </Fragment>
    )
}
export default TablaUsuarios;